import { DocUploaderView } from './DocUploaderView/DocUploaderView';
import { NotAuthorized, NotFound } from './gs-core/client/react/error';
import { TitlesUsedView } from './TitlesUsedView/TitlesUsedView';
import { AppRoute } from './RoutesRenderer';
import { DocListLoader } from './DocListView/DocListLoader';
import { DocLoader } from './DocView/DocLoader';
import { JobsView } from './JobsView/JobsView';

export const routes: AppRoute[] = [
  { path: '/', exact: true, component: DocListLoader },
  { path: '/doc/upload', exact: true, showSidebar: false, component: DocUploaderView },
  { path: '/doc/:docId', exact: true, showSidebar: false, component: DocLoader },
  { path: '/unit', exact: true, component: DocListLoader },
  { path: '/unit/doc/:docId', exact: true, showSidebar: false, component: DocLoader },
  { path: '/unit/:owningUnitId', exact: true, component: DocListLoader },
  { path: '/unit/:owningUnitId/doc/:docId', exact: true, showSidebar: false, component: DocLoader },
  { path: '/unit/:owningUnitId/titles', exact: true, component: TitlesUsedView },
  { path: '/:subjectType/:subjectUserId', exact: true, component: DocListLoader },
  { path: '/:subjectType/:subjectUserId/doc/:docId', exact: true, showSidebar: false, component: DocLoader },
  { path: '/job', exact: true, component: JobsView },
  { path: '/not-authorized', exact: true, showSidebar: false, component: NotAuthorized },
  { component: NotFound }
];



// WEBPACK FOOTER //
// ./src/Routes.tsx